/* Wishlist: product handles stored in localStorage ("shopify-wishlist", comma separated).
   <wishlist-item><button data-product-handle="..."></button></wishlist-item> toggles an item.
   Fires a "wishlist:change" event on document with { detail: { items } } after every change. */
(function () {
  if (customElements.get("wishlist-item")) return;

  var KEY = "shopify-wishlist";
  var DELIMITER = ",";

  var Wishlist = {
    get: function () {
      try {
        var raw = localStorage.getItem(KEY);
        return raw ? raw.split(DELIMITER).filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    },
    set: function (items) {
      var unique = items.filter(function (h, i) { return h && items.indexOf(h) === i; });
      try {
        if (unique.length) localStorage.setItem(KEY, unique.join(DELIMITER));
        else localStorage.removeItem(KEY);
      } catch (e) {}
      Wishlist.updateCounts();
      document.dispatchEvent(new CustomEvent("wishlist:change", { detail: { items: unique } }));
      return unique;
    },
    has: function (handle) { return Wishlist.get().indexOf(handle) !== -1; },
    toggle: function (handle) {
      var items = Wishlist.get();
      var i = items.indexOf(handle);
      if (i === -1) items.push(handle); else items.splice(i, 1);
      return Wishlist.set(items);
    },
    remove: function (handle) {
      return Wishlist.set(Wishlist.get().filter(function (h) { return h !== handle; }));
    },
    clear: function () { return Wishlist.set([]); },
    updateCounts: function () {
      var count = Wishlist.get().length;
      document.querySelectorAll(".wishlist__count").forEach(function (el) {
        el.innerText = count;
      });
      document.querySelectorAll("wishlist-item button[data-product-handle]").forEach(function (btn) {
        btn.classList.toggle("active", Wishlist.has(btn.dataset.productHandle));
      });
    }
  };
  window.AmWishlist = Wishlist;

  class WishlistProduct extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener("click", this.onToggle.bind(this));
      var btn = this.querySelector("button");
      if (btn && btn.dataset.productHandle && Wishlist.has(btn.dataset.productHandle)) btn.classList.add("active");
    }

    onToggle(event) {
      var btn = this.querySelector("button");
      var handle = btn && btn.dataset.productHandle;
      if (!handle) return console.error("[Wishlist] Missing `data-product-handle` attribute.");
      event.preventDefault();
      event.stopPropagation();
      Wishlist.toggle(handle);
      btn.classList.add("loading", "adding");
      setTimeout(function () {
        btn.classList.remove("loading", "adding");
        btn.classList.toggle("active", Wishlist.has(handle));
      }, 400);
    }
  }
  customElements.define("wishlist-item", WishlistProduct);

  // Keep other tabs in sync.
  window.addEventListener("storage", function (e) {
    if (e.key === KEY) {
      Wishlist.updateCounts();
      document.dispatchEvent(new CustomEvent("wishlist:change", { detail: { items: Wishlist.get() } }));
    }
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", Wishlist.updateCounts);
  else Wishlist.updateCounts();
})();
